/* hs-eslint ignored failing-rules */
/* eslint-disable no-prototype-builtins */

import { Component, useState } from 'react';
import PropTypes from 'prop-types';
import UISelect from 'UIComponents/input/UISelect';
import { DEFAULT_REGISTRY, getDefaultFormState } from '../../../utils/defaults';
import { getSchemaTypeI18nKey } from '../../../utils/typeUtils';
import { getParamRowId } from '../../../utils/idUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import DescriptionField from '../DescriptionField';
import UnsupportedField from '../UnsupportedField';
import ObjectField from '../ObjectField';
import DescriptorBlock from '../shared/DescriptorBlock';

// Template component for standard array items
/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function OneOfArrayFieldTemplate(props) {
  const {
    idSchema,
    items: fieldItems,
    oneOfTypes,
    registry = DEFAULT_REGISTRY,
    required,
    schema,
    schemaGroup,
    title,
    changeSelectedType
  } = props;
  const [selectedType, setSelectedType] = useState(null);
  const {
    description
  } = schema;
  const {
    definitions
  } = registry;
  const typeI18nKey = getSchemaTypeI18nKey(schema, definitions);
  return /*#__PURE__*/_jsx("div", {
    className: "params-row",
    "data-test-id": `schema-field-${getParamRowId(idSchema.$id)}`,
    children: /*#__PURE__*/_jsxs("div", {
      className: "params-pair",
      children: [/*#__PURE__*/_jsx(DescriptorBlock
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */, {
        description: description,
        id: idSchema.$id,
        label: title,
        required: required,
        schema: schema,
        schemaGroup: schemaGroup,
        schemaTypeI18nKey: typeI18nKey
      }), /*#__PURE__*/_jsxs("div", {
        className: "params-content",
        children: [description && /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(DescriptionField
          /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */, {
            description: description,
            id: `${idSchema.$id}-description`
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "m-bottom-3",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-shared-components.oneOfDescription"
          }), /*#__PURE__*/_jsx(UISelect, {
            options: oneOfTypes,
            placeholder: 'Select type',
            value: selectedType
            /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */,
            onChange: evt => {
              setSelectedType(evt.target.value);
              changeSelectedType(evt.target.value);
            },
            clearable: true,
            menuWidth: "auto"
          })]
        }), selectedType !== null && fieldItems[selectedType]]
      })]
    })
  });
}
export default class ArrayOneOfField extends Component {
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  constructor(props) {
    super(props);
    this.changeSelectedType = index => {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      const {
        registry,
        schema
      } = this.props;
      const {
        definitions
      } = registry;
      if (schema.items.oneOf[index]) {
        /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
        this.props.onChange([getDefaultFormState(schema.items.oneOf[index], undefined, definitions)]);
      } else {
        /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
        this.props.onChange([]);
      }
    };
    this.state = {
      modified: false,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      oneOfTypes: props.schema.items.oneOf.map((item, i) => {
        return {
          text: item.title,
          value: i
        };
      })
    };
  }

  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */

  renderNormalArray() {
    const {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      disabled,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      errorSchema,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      formData,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      idPrefix,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      idSchema,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      name,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      readOnly,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      registry = DEFAULT_REGISTRY,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      required,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      schema,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      schemaGroup
    } = this.props;
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const {
      oneOfTypes
    } = this.state;
    const title = schema.title === undefined ? name : schema.title;
    const fieldItems = [];
    for (let i = 0; i < schema.items.oneOf.length; i++) {
      fieldItems.push( /*#__PURE__*/_jsx(ObjectField
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */, {
        disabled: disabled,
        errorSchema: errorSchema,
        formData: formData.length > 0 ? formData[0] : formData,
        idPrefix: idPrefix,
        idSchema: idSchema
        /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */,
        onChange: this.props.onChange,
        readOnly: readOnly,
        registry: registry,
        schema: schema.items.oneOf[i]
      }));
    }

    // Standard prop shape for each array template component
    const arrayProps = {
      changeSelectedType: this.changeSelectedType,
      DescriptionField,
      disabled,
      formData,
      idSchema,
      items: fieldItems,
      oneOfTypes,
      readOnly,
      registry,
      required,
      schema,
      schemaGroup,
      title
    };
    const TemplateComponent = OneOfArrayFieldTemplate;
    return /*#__PURE__*/_jsx(TemplateComponent, Object.assign({}, arrayProps));
  }
  render() {
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const {
      idSchema,
      schema
    } = this.props;
    if (!schema.hasOwnProperty('items')) {
      return /*#__PURE__*/_jsx(UnsupportedField
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */, {
        idSchema: idSchema,
        reason: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.params.errors.arrayHasNoItems"
        })
      });
    }
    return this.renderNormalArray();
  }
}

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
ArrayOneOfField.propTypes = {
  disabled: PropTypes.bool,
  errorSchema: PropTypes.object,
  formData: PropTypes.array,
  idPrefix: PropTypes.string,
  idSchema: PropTypes.object,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  registry: PropTypes.object,
  required: PropTypes.bool,
  schema: PropTypes.object.isRequired,
  schemaGroup: PropTypes.string
};

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
ArrayOneOfField.defaultProps = {
  disabled: false,
  formData: [],
  idSchema: {},
  readOnly: false
};